module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-500.17f6ddfe.ttf";